// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";

Rails.start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("trix");
require("@rails/actiontext");
import "bootstrap";
import "src/admin/";

// Copies every image under ../images into the build, for image_pack_tag in views
require.context("../images", true);

import "controllers";
import "../stylesheets/admin";
